import {makeStyles} from "@material-ui/core";
import React from "react";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {Controller, useForm} from "react-hook-form";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import {CustomCheckbox} from "../../../../util";
import editorConfiguration
    from "../../../../util/EditorConfiguration";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import {toast} from "react-toastify";
import {useLocation} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    tabpanel: {
        background: "#FFFFFF",
    },
    textInput: {
        backgroundColor: "white",
        width: "100%",
        marginBottom: "12px",

        "& input": {
            fontSize: "14px",
        },
    },
    content: {
        "& .ck-editor__editable_inline": {
            minHeight: "200px",
        },
    },
    buttonGroup: {
        marginTop: "20px",
        textAlign: "right",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    box: {
        padding: 0,
    },
    innerBox: {
        background: "#ffffff",
        padding: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
}));

const defaultFormValues = {
    subjectEN: "",
    subjectTC: "",
    contentEN: "",
    contentTC: "",
    workingPass: false,
};

function EmailTemplateEdit(props) {
    const {
        match, setLoading, setDisabled,
        getTemplateApi, onSubmitApi
    } = props;
    const location = useLocation();
    const disabled = location.state && location.state.disabled;
    setDisabled(disabled);
    const type = match.params.id;
    const classes = useStyles();
    const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);

    const {control, handleSubmit, reset} = useForm({
        defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    });

    const getTemplate = async () => {
        setLoading(true);
        try {
            const result = await getTemplateApi(type);
            setDefaultValues(result.data);
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    };

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            await onSubmitApi(type, data);
            toast.dark("Template saved.");
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    };

    React.useEffect(() => {
        getTemplate();
    }, []);

    React.useEffect(() => {
        reset(defaultValues);
    }, [defaultValues, reset]);

    console.log(defaultValues);

    return (
        <div className={classes.content}>
            <form>
                <fieldset disabled={disabled}
                          className="fieldset">
                    <Box className={classes.innerBox}
                         style={{marginBottom: 0}}>
                        <Grid container direction="vertical"
                              spacing={4}>
                            <Grid item xs={12}>
                                <Controller
                                    name={`subjectEN`}
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <TextField
                                            label="Subject title (English)"
                                            variant="outlined"
                                            margin="dense"
                                            className={classes.textInput}
                                            fullWidth
                                            {...field}
                                            defaultValue={field.value}
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name={`subjectTC`}
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <TextField
                                            label="Subject title (Traditional Chinese)"
                                            variant="outlined"
                                            margin="dense"
                                            className={classes.textInput}
                                            fullWidth
                                            {...field}
                                            defaultValue={field.value}
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <strong
                                        style={{fontSize: "13px"}}>
                                        Email Content
                                        (English)
                                    </strong>
                                </Grid>
                                <Controller
                                    name="contentEN"
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <CKEditor
                                            editor={Editor}
                                            config={editorConfiguration}
                                            data={field.value || ""}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                field.onChange(data);
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <strong
                                        style={{fontSize: "13px"}}>
                                        Email Content
                                        (Traditional
                                        Chinese)
                                    </strong>
                                </Grid>
                                <Controller
                                    name="contentTC"
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <CKEditor
                                            editor={Editor}
                                            config={editorConfiguration}
                                            data={field.value || ""}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                field.onChange(data);
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <CustomCheckbox/>{" "}
                                <span
                                    style={{fontSize: "13px"}}>Attach working pass</span>
                            </Grid>
                            <Grid item
                                  style={{padding: "0 20px 20px 20px"}}>
                                {disabled || (
                                    <Button
                                        type="button"
                                        variant="contained"
                                        disableElevation
                                        style={{
                                            color: "white",
                                            background: "#306F9D",
                                            marginRight: "5px",
                                            padding: "9px 16px",
                                        }}
                                        onClick={handleSubmit(onSubmit)}
                                    >
                                        Save Changes
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </fieldset>
            </form>
        </div>
    );
}

export default EmailTemplateEdit;
